import { render, staticRenderFns } from "./TeachOtoTag.vue?vue&type=template&id=55c127f9&"
import script from "./TeachOtoTag.vue?vue&type=script&lang=js&"
export * from "./TeachOtoTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports